// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"387":"53f27704","488":"8abd5730","556":"4e7bfa39","580":"1bc7e201","659":"82d0bc3b","722":"466c96bc","784":"51248d14","815":"e4510f98","841":"68b6b453","916":"b7ca0404"}[chunkId] + ".css";
};